import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const deletePaymentMethodById = (data, callback, errorCallBack, params) => {

    return async (dispatch) => {

        formDataCommonFunctionPut(data, apiConstants.PAYMENT_GATEWAY.DELETE_PAYMENT_METHOD_BY_ID)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}

export default deletePaymentMethodById;